import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getFailedToFetchReports, getLastReportGenerationFailed } from '../common/errorMessages';
export var fetchReport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var activeQuizId, setFetchInProgress, setStudentAnalyses, setStatusPollingInProgress, setAnalysisError, setGenerationInProgress, addError, fetchStudentAnalyses, setAnalysisFetchError, getErrorMessageForCode, studentAnalyses, isAnalysisInProgress, isAnalysisFailed, analysisErrorCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          activeQuizId = _ref.activeQuizId, setFetchInProgress = _ref.setFetchInProgress, setStudentAnalyses = _ref.setStudentAnalyses, setStatusPollingInProgress = _ref.setStatusPollingInProgress, setAnalysisError = _ref.setAnalysisError, setGenerationInProgress = _ref.setGenerationInProgress, addError = _ref.addError, fetchStudentAnalyses = _ref.fetchStudentAnalyses, setAnalysisFetchError = _ref.setAnalysisFetchError, getErrorMessageForCode = _ref.getErrorMessageForCode;
          _context.prev = 1;
          setAnalysisFetchError(false);
          setFetchInProgress(true);
          _context.next = 6;
          return fetchStudentAnalyses(activeQuizId);
        case 6:
          studentAnalyses = _context.sent;
          isAnalysisInProgress = studentAnalyses.new_analysis_in_progress;
          isAnalysisFailed = studentAnalyses.last_analysis_failed;
          analysisErrorCode = studentAnalyses.last_analysis_failed_error_code;
          setGenerationInProgress(isAnalysisInProgress);
          setStatusPollingInProgress(isAnalysisInProgress);
          setStudentAnalyses(studentAnalyses.last_successful_analysis);
          setAnalysisError(isAnalysisFailed ? getErrorMessageForCode(analysisErrorCode, getLastReportGenerationFailed()) : null);
          _context.next = 21;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](1);
          setStudentAnalyses(null);
          setAnalysisFetchError(true);
          addError(getFailedToFetchReports());
        case 21:
          _context.prev = 21;
          setFetchInProgress(false);
          return _context.finish(21);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 16, 21, 24]]);
  }));
  return function fetchReport(_x) {
    return _ref2.apply(this, arguments);
  };
}();